import React, { PureComponent } from 'react'

import Title from 'components/App/Title'
import Tracking from 'components/App/Tracking'
import ImpersonationBar from 'components/App/ImpersonationBar'
import SnackbarSwitcher from 'components/App/shared/SnackbarSwitcher'
import { isSafari10, isIE11, isSafari } from 'util/browser'
import { initFavico } from 'util/favicon'
import Page from './Page'

import './sui_base.less'
import './GrooveIcons.font'
import './global.less'

class App extends PureComponent {
  componentDidMount() {
    document.documentElement.classList.toggle('safari', isSafari())
    document.documentElement.classList.toggle('safari10', isSafari10())
    document.documentElement.classList.toggle('ie11', isIE11())
    initFavico()
  }

  render() {
    return (
      <div id="app-inner" className="fullHeight">
        <Title />
        <Tracking />
        <Page />
        <ImpersonationBar />
        <SnackbarSwitcher />
      </div>
    )
  }
}

export default App
